//export const baseUrl = "http://192.168.1.40:8000";
//export const baseUrl = "http://192.168.1.104:8000";
export const baseUrl = process.env.REACT_APP_baseUrl;
//"https://apiuat.dbiexchange.com";
//export const baseUrl = "https://api.dbiexchange.com";